'use client';

import Icon from './Icon';
import svg from 'sprites/rings.svg';

export default function IconRings({
  className='w-4 h-4 fill-none stroke-sand-light'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}